import { getRandom } from 'utils/utils';

const firstNames = [
  'Another',
  'Aghast',
  'Attraction',
  'Broom',
  'Brint',
  'Blob',
  'Chill',
  'Contagion',
  'Clutch',
  'Dickson',
  'Droves',
  'Distinguished',
  'Ember',
  'Entrail',
  'Egg',
  'Food',
  'Flap',
  'Financia',
  'Goop',
  'Grunge',
  'Grievance',
  'Hatter',
  'Handbag',
  'Hayfever',
  'Idle',
  'Ipswitch',
  'Incontinent',
  'Jock',
  'Jobsworth',
  'Jaunty',
  'Kang',
  'Kangg',
  'Kanggg',
  'Lever',
  'Least',
  'Lime',
  'Mint',
  'Muchness',
  'Mink',
  'Namby',
  'Nails',
  'Nitrogen',
  'Oxen',
  'Old',
  'Opportunity',
  'Praline',
  'Prong',
  'Pitiful',
  'Queen',
  'Quasi',
  'Quark',
  'Ravenous',
  'Risky',
  'Rock',
  'Swill',
  'Stolen',
  'Swanky',
  'Tea',
  'Trombone',
  'Tattoo',
  'Uterus',
  'Underworld',
  'Utopia',
  'Vincible',
  'Villainy',
  'Valencia',
  'Witchcraft',
  'Whale',
  'Wang',
  'Xerxes',
  'Xylophone',
  'Xanadu',
  'Yak',
  'Yeovil',
  'Yesman',
  'Zoo',
  'Zebra',
  'Zapp',
];
const lastNames = [
  'Anderson',
  'Adebayo',
  'Abstract',
  'Brown',
  'Blanc',
  'Buttock',
  'Cockburn',
  'Crepe',
  'Catastrophe',
  'Dixon',
  'Di Mateo',
  'Draper',
  'Evans',
  'Edwards',
  'Esteem',
  'French',
  'Fernandez',
  'Factual',
  'Green',
  'Gruber',
  'Gunslinger',
  'Hudson',
  'Hernandez',
  'Hippo',
  'Illingworth',
  'Ibrahim',
  'Indigestion',
  'Jones',
  'Jackson',
  'Joker',
  'Kennedy',
  'Khan',
  'Knight',
  'Lawson',
  'Liu',
  'Limerick',
  'Miller',
  'Musa',
  'Mansplainer',
  'Nixon',
  'Nowhere',
  'Nonethewiser',
  'Olson',
  'Owens',
  'Obligation',
  'Papadopoulos',
  'Patel',
  'Pint',
  'Quentin',
  'Quantock',
  'Quarterback',
  'Richardson',
  'Richard',
  'Reckless',
  'Simon',
  'Singh',
  'Sympathy',
  'Taylor',
  'Takeshi',
  'Tourism',
  'Underhill',
  'Uppity',
  'Uber',
  'Vance',
  'Vanity',
  'Van Damme',
  'Wilson',
  'Wang',
  'Wallowing',
  'Xenon',
  'Xerox',
  'Xavier',
  'Yapp',
  'Ying',
  'Yellow',
  'Zaltzman',
  'Zabinski',
  'Zigzag',
];

export default () => `${getRandom(firstNames)} ${getRandom(lastNames)}`;
